namespace TabAurous.ECommerce {
    export namespace PickUpOrderItemsSelectService {
        export const baseUrl = 'ECommerce/PickUpOrderItemsSelect';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ECommOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ECommerce/PickUpOrderItemsSelect/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>PickUpOrderItemsSelectService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
